// src/components/MaintenanceLists/BikeEditModal.js
import React from 'react';
import Modal from '../Modal';
import BikeForm from './BikeForm';

/**
 * Modal component for editing motorcycle details
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Object|null} props.editedBike - Bike data being edited
 * @param {Function} props.setEditedBike - Function to update edited bike data
 * @param {Function} props.updateBike - Function to save the updated bike
 * @returns {JSX.Element|null} Rendered component or null if editedBike is null
 */
const BikeEditModal = ({ isOpen, onClose, editedBike, setEditedBike, updateBike }) => {
  if (!editedBike) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Motorcycle Details"
    >
      <div className="edit-bike-modal">
        <BikeForm
          bike={editedBike}
          setBike={setEditedBike}
          onSubmit={updateBike}
          onCancel={onClose}
          submitButtonText="Save Changes"
          isEdit={true}
        />
      </div>
    </Modal>
  );
};

export default BikeEditModal;